export default class AgentAnnouncementLinkDTO {

  constructor(jsonResponse) {
    this.id = jsonResponse["id"];
    this.agentAnnouncementId = jsonResponse["agent-announcement-id"];
    this.link = jsonResponse["link"];
    this.active = jsonResponse["active"];
  }

  static toJson = function (obj) {
    let jsonObj = {};
    jsonObj["id"] = obj.id;
    jsonObj["agentAnnouncementId"] = obj.agentAnnouncementId;
    jsonObj["link"] = obj.link;
    jsonObj["active"] = obj.active;
    return jsonObj;
  }

}
